import { Icon, Text } from "@ttc3k/trekker";
import {
  CheckCircleSolid,
  MinusCircleSolid,
  XmarkCircleSolid,
} from "iconoir-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "styled-system/jsx";
import type { ChecklistStatus } from "./useMembershipChecklist";

const STATUS_ICON = {
  done: { Element: CheckCircleSolid, color: "icon.success.mid" },
  notRelevant: { Element: MinusCircleSolid, color: "icon.warning.mid" },
  notDone: { Element: XmarkCircleSolid, color: "icon.error.mid" },
} as const;

type ChecklistItemProps = {
  status: ChecklistStatus;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
};

export const ChecklistItem = ({
  status,
  title,
  children,
  action,
}: ChecklistItemProps) => {
  const { t } = useTranslation("home", {
    keyPrefix: "VIEWS.SETTINGS.VIEWS.MEMBERSHIP_TIERS.CHECKLIST",
  });
  const { Element, color } = STATUS_ICON[status];

  return (
    <Flex
      gap="200"
      py="250"
      borderBottomWidth="1px"
      borderColor="border.light"
      _last={{ borderBottomWidth: 0 }}
    >
      <Icon
        Element={Element}
        color={color}
        flexShrink={0}
        mt="25"
        aria-label={t(`STATUS.${status}`)}
      />
      <Flex flexDir="column" gap="100" flex={1} minW={0}>
        <Text visual="bodySemiBold" color="text.dark">
          {title}
        </Text>
        {children}
        {action && (
          <Flex gap="200" alignItems="center" flexWrap="wrap" pt="50">
            {action}
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};
